module.exports = __webpack_public_path__ + "static/img/8.0c92a7c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/3/zh/8.png
// module id = KGGt
// module chunks = 0